import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorProperties } from '../../API/identityAPIProperties';
import API from '../../API/Main/API';
import { resetState } from '../../resetState';
import { BranchProperties, UserBranchProperties } from '../../API/ClientAPIHelpers/branchProperties';

export const getUserBranches = createAsyncThunk('users/branch/branches', async (id: string, thunkAPI) => {
	const response = await API.UserAPI.Branch.getUserBranches(id);

	if (response.error) {
		return thunkAPI.rejectWithValue(response.error);
	}

	return response as BranchProperties[];
});

export const addUserToBranches = createAsyncThunk('users/branch/add', async (data: UserBranchProperties, thunkAPI) => {
	const response = await API.UserAPI.Branch.addUserToBranch(data);

	if (response.error) {
		return thunkAPI.rejectWithValue(response.error);
	}

	return response;
});

interface BranchInitialStateProperties {
	error: ErrorProperties;
	isFetching: boolean;
	loading: boolean;
	userBranches: BranchProperties[];
}

const initialBranchState: BranchInitialStateProperties = {
	isFetching: false,
	loading: false,
	error: {
		status: 0,
		title: '',
	},
	userBranches: [],
};

const branchSlice = createSlice({
	name: 'branch',
	initialState: initialBranchState,
	reducers: {},
	extraReducers: (builder) => {
		// getUserBranches
		builder.addCase(getUserBranches.pending, (state) => {
			state.isFetching = true;
			state.error = initialBranchState.error;
		});
		builder.addCase(getUserBranches.fulfilled, (state, action) => {
			state.isFetching = false;
			state.userBranches = action.payload;
		});
		builder.addCase(getUserBranches.rejected, (state, action) => {
			state.isFetching = false;
			state.error = action.payload as ErrorProperties;
		});

		// addUserToBranches
		builder.addCase(addUserToBranches.pending, (state) => {
			state.loading = true;
			state.error = initialBranchState.error;
		});
		builder.addCase(addUserToBranches.fulfilled, (state) => {
			state.loading = false;
		});
		builder.addCase(addUserToBranches.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload as ErrorProperties;
		});

		// reset state
		builder.addCase(resetState, () => initialBranchState);
	},
});

export default branchSlice.reducer;
